/**
 * Parwaaz — i18n entry point: dictionary type, lookup and interpolation.
 */
import { en } from './en';
import { hi } from './hi';

export type Dict = Record<string, string>;

const DICTS: Record<string, Dict> = { en, hi };

/** The dictionary for `lang`, falling back to English for an unknown language. */
export function getDict(lang: string): Dict {
  return DICTS[lang] ?? DICTS.en;
}

/** Look up `key` in `dict`, interpolating `{varName}` placeholders from `vars`. Falls back to the key itself when missing. */
export function t(dict: Dict, key: string, vars?: Record<string, string | number>): string {
  const raw = dict[key] ?? key;
  if (!vars) return raw;
  return raw.replace(/\{(\w+)\}/g, (match, name: string) => (name in vars ? String(vars[name]) : match));
}

export { en, hi };
